import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import AlertComponent from "../components/AlertComponent";
import {
  deleteSensor,
  editSensor,
  postSensor,
} from "../redux/action/sensorAction";
import ModalComponent from "../components/ModalComponent";
import { openForm } from "../redux/slice/sensorSlice";
import { getSitesList } from "../redux/action/sitesAction";
import { SelectInput, SelectSearch } from "../components/InputComponent";
import { getDeviceList, getDeviceMinio } from "../redux/action/deviceAction";
import { getAnalyticList } from "../redux/action/analyticAction";
import { getCameraBySitesId, getCameraList } from "../redux/action/cameraAction";

const FormSensor = ({ param }) => {
  const { idSensor, dataByIdSensor, isOpenForm, state } = useSelector( (state) => state.sensor );
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { dataSitesList } = useSelector( (state) => state.sites );
  const { dataDeviceList, dataDevicesMinio } = useSelector( (state) => state.device );
  const { dataAnalyticList } = useSelector( (state) => state.analytic );
  const { dataCameraList, dataCameraBySites } = useSelector( (state) => state.camera );
  const [optionSites, setOptionSites] = useState([])
  const [optionDevice, setOptionDevice] = useState([])
  const [optionAnalytic, setOptionAnalytic] = useState([])
  const [optionCamera, setOptionCamera] = useState([])
  const [optionMinio, setOptionMinio] = useState([])
  const [analyticId, setAnalytic] = useState('')
  const [camId, setCamera] = useState('')
  const [siteId, setSite] = useState('')
  const [devId, setDevice] = useState('')
  const [minio, setMinio] = useState('')
  
  // console.log(dataCameraBySites)

  const initialValues = {
    siteId: idSensor === "" ? "" : dataByIdSensor.siteId,
    devId: idSensor === "" ? "" : dataByIdSensor.devId,
    analyticId: idSensor === "" ? "" : dataByIdSensor.analyticId,
    camId: idSensor === "" ? "" : dataByIdSensor.camId,
    name: idSensor === "" ? "" : dataByIdSensor.name,
    value: idSensor === "" ? "" : dataByIdSensor.value,
    zmqAddress: idSensor === "" ? "" : dataByIdSensor.zmqAddress,
    zmq: idSensor === "" ? "" : dataByIdSensor.zmq,
    detDuration: idSensor === "" ? "" : dataByIdSensor.detDuration,
    confidenceVal: idSensor === "" ? "" : dataByIdSensor.confidenceVal,
    skipFrame: idSensor === "" ? "" : dataByIdSensor.skipFrame,
    lineDetection: idSensor === "" ? "" : dataByIdSensor.lineDetection,
    getiFile: idSensor === "" ? "" : dataByIdSensor.getiFile,
    minioId: idSensor === "" ? "" : dataByIdSensor.minioId,
  };
  const validationSchema = Yup.object().shape({
    // siteId: Yup.string().required("Sensor Name is required!"),
    // devId: Yup.string().required("Device is required!"),
    // analyticId: Yup.string().required("Analytic is required!"),
    // camId: Yup.string().required("Camera is required!"),
    // name: Yup.string().required("Name is required!"),
    // value: Yup.string().required("Value is required!"),
  });
  const resetOption = () =>{

    setAnalytic('')
    setCamera('')
    setSite('')
    setDevice('')
    setMinio('')
  }
  const handleFormSubmit = async (values) => {
    if (state === "add") {
      param.data = values;
      // console.log(param.data);
      dispatch(postSensor(param));
      resetOption()
    } else if (state === "edit") {
      param.data = values;
      param.id = idSensor;
      dispatch(editSensor(param));
      resetOption()
    } else {
      param.id = idSensor;
      dispatch(deleteSensor(param));
      resetOption()
    }
  };

  const newAnalytic = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH ANALYTIC -', id: '' }]
    dataAnalyticList.map((row, index) => {
      arr.push({ name: row.analyticName, id: row.analyticId })
    })
    setOptionAnalytic(arr)
    
  }
  useEffect(() => {
    newAnalytic()
  }, [])
  useEffect(() => {
    if (dataAnalyticList.length > 0) {
      newAnalytic()
    }
  }, [dataAnalyticList])

  const newMinio = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH DEVICE TIPE -', id: '' }]
    dataDevicesMinio.map((row, index) => {
      arr.push({ name: row.devName, id: row.devId })
    })
    setOptionMinio(arr)
    
  }
  useEffect(() => {
    newMinio()
  }, [])
  useEffect(() => {
    if (dataDevicesMinio.length > 0) {
      newMinio()
    }
  }, [dataDevicesMinio])

  const newCamera = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH KAMERA -', id: '' }]
    dataCameraList.map((row, index) => {
      arr.push({ name: row.name, id: row.id })
    })
    setOptionCamera(arr)
    
  }
  useEffect(() => {
    newCamera()
  }, [])
  useEffect(() => {
    if (dataCameraList.length > 0) {
      newCamera()
    }
  }, [dataCameraList])

  const newSites = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH SITES -', id: '' }]
    dataSitesList.map((row, index) => {
      arr.push({ name: row.siteName, id: row.siteId })
    })
    setOptionSites(arr)
    
  }
  useEffect(() => {
    newSites()
  }, [])
  useEffect(() => {
    if (dataSitesList.length > 0) {
      newSites()
    }
  }, [dataSitesList])

  const newDevice = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH DEVICE -', id: '' }]
    dataDeviceList.map((row, index) => {
      arr.push({ name: row.devName, id: row.devId })
    })
    setOptionDevice(arr)
    
  }
  useEffect(() => {
    newDevice()
  }, [])
  useEffect(() => {
    if (dataDeviceList.length > 0) {
      newDevice()
    }
  }, [dataDeviceList])

  useEffect(() => {
    dispatch(getSitesList(param));
    dispatch(getDeviceList(param));
    dispatch(getAnalyticList(param));
    dispatch(getCameraList(param));
    dispatch(getDeviceMinio(param));
  }, []);

  return state === "delete" ? (
    <AlertComponent
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, state: "close" }))}
      action={() => handleFormSubmit()}
    />
  ) : (
    <ModalComponent
      title={state === "add" ? "TAMBAH SENSOR" : "EDIT SENSOR"}
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, type: "close" }))}
      idForm="sensor-form"
    >
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} id="sensor-form">
            <div className="row align-items-center" style={{ color: "white" }}>
              <div className="form-group row mb-3">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Name
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="name"
                    id="name"
                    className="form-control"
                    value={values.name}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.name && errors.name && (
                    <span style={{ color: "white" }}>{errors.name}</span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                  Value
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="value"
                    id="value"
                    className="form-control"
                    value={values.value}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.value && errors.value && (
                    <span style={{ color: "white" }}>{errors.value}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Site Id
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <SelectInput
                    onChange={(e) => {
                      dispatch(
                        getCameraBySitesId({
                          sites: e.target.value,
                          token: user.access_token,
                        }),
                      )
                      handleChange({
                        target: { name: 'siteId', value: e.target.value },
                      })
                      // console.log(e.target.value)
                      // let event = { target: { name: 'siteId', value: e.target.value } }
                        setSite(e.target.value)
                      //   handleChange(event)
                        setCamera('')
                    }}
                    name="siteId"
                    id="siteId"
                    value={values.siteId}
                    option={optionSites}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                      helperText: touched.siteId && errors.siteId,
                      error: Boolean(errors.siteId && touched.siteId),
                    }}
                  />
                  {touched.siteId && errors.siteId && (
                    <span>{errors.siteId}</span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label">
                  Device Id
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                   <SelectInput
                      onChange={(e) => {
                        // console.log(e.target.value)
                        let event = { target: { name: 'devId', value: e.target.value } }
                          setDevice(e.target.value)
                          handleChange(event)
                      }}
                      name="devId"
                      id="devId"
                      value={values.devId}
                      option={optionDevice}
                      validation={''}
                      props={{
                      onBlur: handleBlur,
                      helperText: touched.devId && errors.devId,
                      error: Boolean(errors.devId && touched.devId),
                    }}
                  />
                  {touched.devId && errors.devId && (
                    <span>{errors.devId}</span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                  Analytic Id
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                    <SelectInput
                      onChange={(e) => {
                        // console.log(e.target.value)
                        let event = { target: { name: 'analyticId', value: e.target.value } }
                          setAnalytic(e.target.value)
                          handleChange(event)
                      }}
                      name="analyticId"
                      id="analyticId"
                      value={values.analyticId}
                      option={optionAnalytic}
                      validation={''}
                    props={{
                      onBlur: handleBlur,
                      helperText: touched.analyticId && errors.analyticId,
                      error: Boolean(errors.analyticId && touched.analyticId),
                    }}
                    />
                    {touched.analyticId && errors.analyticId && (
                      <span>{errors.analyticId}</span>
                    )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Camera Id
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                    <SelectInput
                      onChange={(e) => {
                        // console.log(e.target.value)
                        let event = { target: { name: 'camId', value: e.target.value } }
                          setCamera(e.target.value)
                          handleChange(event)
                      }}
                      name="camId"
                      id="camId"
                      value={values.camId}
                      option={dataCameraBySites}
                      validation={''}
                    props={{
                      onBlur: handleBlur,
                      helperText: touched.camId && errors.camId,
                      error: Boolean(errors.camId && touched.camId),
                    }}
                    />
                    {touched.camId && errors.camId && (
                      <span>{errors.camId}</span>
                    )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Alamat ZMQ
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="zmqAddress"
                    id="zmqAddress"
                    className="form-control"
                    value={values.zmqAddress}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.zmqAddress && errors.zmqAddress && (
                    <span style={{ color: "white" }}>{errors.zmqAddress}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  ZMQ 
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="zmq"
                    id="zmq"
                    className="form-control"
                    value={values.zmq}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.zmq && errors.zmq && (
                    <span style={{ color: "white" }}>{errors.zmq}</span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                  Durasi 
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="detDuration"
                    id="detDuration"
                    className="form-control"
                    value={values.detDuration}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.detDuration && errors.detDuration && (
                    <span style={{ color: "white" }}>{errors.detDuration}</span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                  Nilai Confidence 
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="confidenceVal"
                    id="confidenceVal"
                    className="form-control"
                    value={values.confidenceVal}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.confidenceVal && errors.confidenceVal && (
                    <span style={{ color: "white" }}>{errors.confidenceVal}</span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                  Garis Lewat Bingkai
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="skipFrame"
                    id="skipFrame"
                    className="form-control"
                    value={values.skipFrame}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.skipFrame && errors.skipFrame && (
                    <span style={{ color: "white" }}>{errors.skipFrame}</span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                  Garis Deteksi
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="lineDetection"
                    id="lineDetection"
                    className="form-control"
                    value={values.lineDetection}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.lineDetection && errors.lineDetection && (
                    <span style={{ color: "white" }}>{errors.lineDetection}</span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                   Nama File Geti
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="getiFile"
                    id="getiFile"
                    className="form-control"
                    value={values.getiFile}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.getiFile && errors.getiFile && (
                    <span style={{ color: "white" }}>{errors.getiFile}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  List Minio
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                    <SelectInput
                      onChange={(e) => {
                        // console.log(e.target.value)
                        let event = { target: { name: 'minioId', value: e.target.value } }
                          setMinio(e.target.value)
                          handleChange(event)
                      }}
                      name="minioId"
                      id="minioId"
                      value={values.minioId}
                      option={optionMinio}
                      validation={''}
                    props={{
                      onBlur: handleBlur,
                      helperText: touched.minioId && errors.minioId,
                      error: Boolean(errors.minioId && touched.minioId),
                    }}
                    />
                    {touched.minioId && errors.minioId && (
                      <span>{errors.minioId}</span>
                    )}
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default FormSensor;
